import React from 'react';
import {Swiper, SwiperSlide} from "swiper/react";
import 'swiper/css';
import SliderItem from "./SliderItem";
import styled from "styled-components";
import {useAppSelector} from "../../hooks/hooks";


const Slider: React.FC = () => {
    const codesData = useAppSelector((state) => state.codes.data)
    const demoCodesData = useAppSelector((state) => state.tutorial.completeCodes)

    return (
        <Container>
            {codesData.length &&
                <Swiper
                    initialSlide={codesData.length}
                    spaceBetween={8}
                    slidesPerView={"auto"}
                    centeredSlides={true}
                >
                    {demoCodesData && demoCodesData.map((code, index) => <StyledSwiperSlide key={index}><SliderItem code={code}/></StyledSwiperSlide>)}
                    {codesData && codesData.map((code, index) => <StyledSwiperSlide key={index + 1}><SliderItem code={code}/></StyledSwiperSlide>)}
                </Swiper>
            }
        </Container>
    );
};

export default Slider;

const Container = styled.div`
    margin-top: 12px;
`
const StyledSwiperSlide = styled(SwiperSlide)`
    width: 90%;
    padding: 18px 0 0;
`;
